    <template>
      <div class="container my-5">
          <div v-if="transaction.txHash" class="detail">
            <div class="detail-title">Transaction Details</div>
            <div class="detail-tab pt-3">
              <div @click="showTab=0" :class="showTab==0 ?'detail-tab-text-click':''" class="detail-tab-text">Overview</div>
              <div v-if="eventList && eventList.length > 0" @click="showTab=1" :class="showTab==1 ?'detail-tab-text-click':''" class="detail-tab-text">Logs ({{eventList.length}})</div>
              <div v-if="internalList && internalList.length > 0" @click="actionInternalTxns(showTab=2)" :class="showTab==2 ?'detail-tab-text-click':''" class="detail-tab-text">Internal Txns</div>
            </div>

<!--            overview-->
            <div v-show="showTab==0" class="detail-content">
<!--              hash-->
              <div class="detail-content-item">
                <span>Transaction Hash :</span>
                <span> {{ transaction.txHash }}</span>
                <Copy :data="transaction.txHash"/>
              </div>
<!--              status-->
              <div class="detail-content-item detail-content-item-s">
                <span>Status :</span>
                <div v-if="transaction.status == 1" class="detail-status-success">
                  <button>Success</button>
                </div>
                <div v-else class="detail-status-error">
                  <button>{{transaction.error}}</button>
                </div>
              </div>
<!--              block-->
              <div class="detail-content-item detail-content-item-s">
                <span>Block :</span>
                <div>
                  <span class="detail-item-red"><router-link :to="`/block/${transaction.number}`">{{ transaction.number }}</router-link></span>
                  <span v-if="blockHeight != 0" class="detail-item-gray">({{ parseFloat(blockHeight) - parseFloat(transaction.number) }} Block Confirmations)</span>
                  <span v-else class="detail-item-gray">( 0 Block Confirmations)</span>
                </div>
              </div>
<!--              timestamp-->
              <div class="detail-content-item detail-content-item-s">
                <span>Timestamp :</span>
                <div>
                  {{updateTimestamp(transaction.timestamp)}}<span class="detail-item-gray">({{blockDate(transaction.timestamp)}})</span>
                </div>
              </div>

<!--              from-->
              <div class="detail-content-item detail-content-item-s">
                <span>From :</span>
                <span class="detail-item-from detail-item-red"> <router-link :to="`/address/${transaction.from}`"> {{ transaction.from }} </router-link></span>
                <Copy :data="transaction.from"/>
              </div>


 <!--              to-->
              <div v-if="transaction.contract" class="detail-content-item detail-content-item-s">
                <span>To :</span>
                <span v-if="contract && contract.symbol" class="detail-item-from detail-item-red"><router-link :to="`/address/${transaction.contract}`">Create contract: {{ transaction.contract }} ({{ contract.symbol }})</router-link></span>
                <span v-else class="detail-item-from detail-item-red">Create contract: <router-link :to="`/address/${transaction.contract}`">{{ transaction.contract }}</router-link></span>
                <Copy :data="transaction.contract"/>
              </div>

              <div v-else-if="!contract" class="detail-content-item detail-content-item-s">
                <span>To :</span>
                <span class="detail-item-from detail-item-red"> <router-link :to="`/address/${transaction.to}`"> {{ transaction.to }} </router-link></span>
                <Copy :data="transaction.to"/>
              </div>


              <div v-else class="detail-content-item detail-content-item-s">
                <span>To :</span>
                <span class="detail-item-from d-flex flex-row align-items-center">
<!--                  <img class="detail-item-token-icon mr-3" src="../../images/token/eth.png"/>-->
                  <div class="font-weight-bold pr-1">Contract</div>
                    <router-link :to="`/address/${contract.address}`"> {{getSortAddress(contract.address)}}</router-link>
                    <span v-if="contract && contract.name" class="pl-1">({{contract.name}} : {{ contract.symbol }})</span>
                </span>
                <Copy :data="contract.address"/>
              </div>

<!--              transaction-->
              <div v-if="methodList && methodList.length > 0" class="detail-content-item detail-content-item-s">
                <span>Transaction Actions :</span>
                <div v-for="(item,index) in methodList" :key="index" class="d-flex flex-row align-items-center">
                  <div class="d-flex flex-row align-items-center"> {{ item.methods }}
                    <span class="pl-1" style="font-weight: 700"> {{ item.contract }} </span>
                  </div>
                  <img v-if="item.iconUrl" class="detail-item-token-icon ml-2 mr-1" :src="item.iconUrl"/>
                  <img v-else class="detail-item-token-icon ml-2 mr-1 mb-1" src="../../images/token/erc-token-black.png"/>
                  <span class="detail-item-red"> {{ item.name }} ({{item.symbol}})</span>
                </div>
              </div>

<!--              token-->
              <div v-if="tokenTranList && tokenTranList.length > 0" class="detail-content-item detail-content-item-s detail-content-item-trans">
                <span>Token Transferred :</span>
                <div class="d-flex flex-column align-items-start">
                  <div v-show="showTanfers==false"  v-for="(item,index) in  tokenTranTenList" :key="index" class="trans-token">
                    <div>
                      <span class="pr-2">From</span>
                      <span class="detail-item-red pr-2">
                        <router-link :to="`/address/${item.from}`">{{ getSortAddress(item.from) }}</router-link>
                      </span>
                    </div>
                    <div>
                      <span class="pr-2">To</span>
                      <span class="detail-item-red pr-2">
                        <router-link :to="`/address/${item.to}`">{{ getSortAddress(item.to) }}</router-link>
                      </span>
                    </div>
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <div v-if="item.type == 1" class="d-flex flex-row align-items-center">Transfer <div class="pl-1" style="font-weight: 700"> {{ item.val }} </div></div>
                      <div v-if="item.type == 2" class="d-flex flex-row align-items-center">For MRC721 <div  class="pl-1" style="font-weight: 700;width: 80px"> TokenId [{{ item.tokenId }}]</div></div>
                      <router-link style="margin-top: -5px" class="d-flex flex-row align-items-center" :to="`/token/${item.contract}`">
                        <img v-if="item.iconUrl" class="detail-item-token-icon ml-2 mr-1" :src="item.iconUrl"/>
                        <img v-else-if="!item.iconUrl && item.type == 1" class="detail-item-token-icon ml-2 mr-1" src="../../images/token/erc-token-black.png"/>
                        <img v-else-if="!item.iconUrl && item.type == 2" class="detail-item-token-icon mr-1" src="../../images/token/nft-token-black.png"/>
                        <div class="detail-item-red pt-1" > {{ item.name }} ({{item.symbol}}) </div>
                      </router-link>
                    </div>
                  </div>
                  <div @click.prevent.stop="showTanfers=true"  v-if="showTanfers==false && tokenTranList.length>10"   class="mt-3 d-flex flex-row align-items-center" style="cursor: pointer">
                     <div class="font-weight-bold">Click to see more</div>
                     <img class="ml-2" style="width: 9px" src="../../images/transtion/arrow-bottom-red.png"/>
                  </div>
                  <div v-show="showTanfers">
                    <div v-for="(item,index) in tokenTranList" :key="index" class="trans-token">
                      <div>
                        <span class="pr-2">From</span>
                        <span class="detail-item-red pr-2">
                          <router-link :to="`/address/${item.from}`">{{ getSortAddress(item.from) }}</router-link>
                        </span>
                      </div>
                      <div>
                        <span class="pr-2">To</span>
                        <span class="detail-item-red pr-2">
                          <router-link :to="`/address/${item.to}`"> {{ getSortAddress(item.to) }}</router-link>
                        </span>
                      </div>
                      <div class="d-flex flex-row align-items-center justify-content-center">
                        <div v-if="item.type == 1" class="d-flex flex-row align-items-center">Transfer <div class="pl-1" style="font-weight: 700"> {{ item.val }} </div></div>
                        <div v-if="item.type == 2" class="d-flex flex-row align-items-center">For MRC721 <div class="pl-1" style="font-weight: 700;width: 80px"> TokenId [{{ item.tokenId }}]</div></div>
                        <router-link class="d-flex flex-row align-items-center" style="margin-top: -5px" :to="`/token/${item.contract}`">
                          <div>{{item.iconUrl}}</div>
                          <img v-if="item.iconUrl" class="detail-item-token-icon ml-2 mr-1" :src="item.iconUrl"/>
                          <img v-else-if="!item.iconUrl && item.type == 1" class="detail-item-token-icon ml-2 mr-1" src="../../images/token/erc-token-black.png"/>
                          <img v-else-if="!item.iconUrl && item.type == 2" class="detail-item-token-icon mr-1" src="../../images/token/nft-token-black.png"/>
                          <div class="detail-item-red"> {{ item.name }} ({{item.symbol}}) </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

<!--              value-->
              <div class="detail-content-item detail-content-item-s">
                <span>Value :</span>
                <span>{{ parseBalance(transaction.value) }} MAPO</span>
              </div>

<!--              fee-->
              <div class="detail-content-item detail-content-item-s">
                <span>Transaction Fee :</span>
                <span>{{ getTransactionFee(transaction) }} MAPO</span>
              </div>

<!--              gas-->
              <div class="detail-content-item detail-content-item-s">
                <span>Gas Price :</span>
                <span>{{ parseValToGWei(transaction.gasPrice) }} GWEI</span>
              </div>

              <div class="detail-content-line"></div>

<!--              click-->
              <div class="detail-more">
                <button @click="showClick=!showClick">
                  Click to see more
                  <div>
                    <img v-if="showClick==false" src="../../images/transtion/arrow-bottom-red.png"/>
                    <img v-else src="../../images/transtion/arrow-top-red.png"/>
                  </div>
                </button>
              </div>

              <div class="detail-content-click" v-show="showClick">
<!--                gas limit-->
                <div class="detail-content-item detail-content-item-s">
                  <span>Gas Limit & Gas Used:</span>
                  <span> {{ transaction.gas }} | {{ transaction.gasUsed }}  <span class="detail-item-gray">({{ (transaction.gasUsed / transaction.gas * 100).toFixed(2) }}%)</span></span>
                </div>

<!--                gas used-->
                <div v-if="transaction.type == 2" class="detail-content-item detail-content-item-s">
                  <span>Gas Fees :</span>
                  <span> Base: {{ parseValToGWei(transaction.baseFeePerGas)  }} GWei | Max: {{ parseValToGWei(transaction.maxFeePerGas) }} GWei | Max Priority: {{ parseValToGWei(transaction.maxPriorityFeePerGas) }} GWei<span class="detail-item-gray">( {{ (transaction.maxPriorityFeePerGas / transaction.maxFeePerGas * 100).toFixed(2)}}% )</span></span>
                </div>

<!--                nonce-->
                <div class="detail-content-item detail-content-item-s">
                  <span>Nonce :</span>
                  <span> {{ transaction.nonce }}
<!--                    <span class="detail-item-gray">(At Index 5 in Block)</span>-->
                  </span>
                </div>

              <!--  <div v-if="methodsDetail!==null" class="detail-content-item detail-content-item-s">
                  <span>Event :</span>
                  <span> {{methodsDetail.name}} ({{ methodsDetail.params }})</span>
                </div> -->

<!--                input data -->
                <div class="detail-content-item detail-content-item-s">
                  <span>Input Data :</span>
                  <div  v-if="methodsDetail!==null " class="detail-item-input">
                    <div v-show="showDefaultView==0">
                      <div>Function &nbsp;: &nbsp;{{methodsDetail.name}} ({{ methodsDetail.params }})</div>
                      <div class="pt-3">MethodID &nbsp;: &nbsp;{{methodsDetail.key}}</div>
                      <div class="detail-item-input-num pt-2" v-for="(item,index) in inputDataArr" :key="index">
                        <span>[{{index}}]&nbsp;:</span>{{ item }}
                      </div>
                    </div>
                    <div v-show="showDefaultView==1" class="detail-item-input-text">
                      <span>{{ transaction.input }}</span>
                    </div>
                  </div>
                  <div v-else class="detail-item-input">
                    <div>{{ transaction.input }}</div>
                  </div>
                </div>
                <div class="detail-content-item pt-2">
                  <span></span>
                  <div class="detail-item-view" v-if="methodsDetail!==null">
                      <button @click="showViewInput = !showViewInput">
                        View Input As
                        <img src="../../images/block/arrow-bottom-white.png"/>
                      </button>
                      <div v-show="showViewInput" class="detail-item-view-tab">
                        <span @click="colseViewInputTab(showDefaultView=0)" :class="showDefaultView==0? 'fontcolor-blue':''">Default View</span>
                        <span @click="colseViewInputTab(showDefaultView=1)" :class="showDefaultView==1? 'fontcolor-blue':''">Original</span>
                      </div>
                  </div>
                </div>




              </div>


            </div>

<!--            logs-->
            <div v-show="showTab==1" class="detail-content detail-content-two">
<!--                address-->
              <div v-for="(item,index) in eventList" class="log-content" :key="index">
                <div class="detail-content-item">
                  <span>LogIndex :</span>
                  <span class="detail-item-from d-flex flex-row align-items-center">{{item.logIndex}}</span>
                </div>
              <div class="detail-content-item detail-content-item-s">
                <span>Address :</span>
                <span class="detail-item-from d-flex flex-row align-items-center">
                  <img v-if="item.contractEntity && item.contractEntity.iconUrl" :src="item.contractEntity.iconUrl" class="detail-item-token-icon  mr-3" />
                  <img v-else-if="!item.contractEntity"/>
                  <img v-else-if="item.contractEntity && (item.contractEntity.type==0 || item.contractEntity.type==1) " class="detail-item-token-icon mr-3" src="../../images/token/erc-token-black.png"/>
                  <img v-else class="detail-item-token-icon mr-3" src="../../images/token/nft-token-black.png"/>
                  <span v-if="item.contractEntity && item.contractEntity.symbol" class="detail-item-red pt-1"> <router-link :to="`/address/${item.contract}`">{{ item.contractEntity.symbol }}</router-link>  Contract</span>
                  <span v-else class="detail-item-red pt-1"> <router-link :to="`/address/${item.contract}`">{{ item.contract }}</router-link>  </span>
                </span>
                <Copy :data="item.contract "/>
              </div>

<!--              event-->
            <div v-if="item.methodsEntity" class="detail-content-item detail-content-item-s">
                <span>Event :</span>
              <div class="d-flex flex-row align-items-center">
                  <span  class="detail-item-gray pl-0 w-auto">{{ item.methodsEntity.name }} (</span>
                <div  v-if="item.methodsEntity.params" >
                 <!-- <div class="d-flex flex-row" v-for="(item1,index1) in JSON.parse(item.methodsEntity.params)" :key="index1">
                     <div v-if="item1.type == 'address'" class="detail-item-gray w-100">indexed </div>
                     <div class="detail-item-green"> {{ item1.type }}, </div>
                     <div v-if="index1 != JSON.parse(item.methodsEntity.params).length - 1" class="detail-item-red"> {{ item1.name }}, </div>
                     <div v-else class="detail-item-red"> {{ item1.name }}</div>
                   </div>-->
                  {{item.methodsEntity.params}}
                </div>
                 <span class="detail-item-gray pl-0"> )</span>
               </div>
              </div>

<!--              topics-->
              <div class="detail-content-item detail-content-item-s detail-content-item-topics">
                <span>Topics :</span>
                <div class="detail-item-from d-flex flex-column align-items-start justify-content-start">
                    <div v-for="(i,index) in item.logs.substring(1, item.logs.length -1).split(',')" :key="index" class="detail-item-topics">
                      <span>{{index}}</span>
                      <img src="../../images/transtion/arrow-right.png"/>
                      <span>{{i.replaceAll('"', "")}}</span>
                    </div>
                </div>

              </div>

              <div class="detail-content-item detail-content-item-s">
                <span>Data :</span>
                <div class="detail-item-input d-flex flex-column align-items-start">
                  <div v-if="item.data=='0x'"></div>
                  <div v-else v-for="index in item.data.substring(2).length /64" :key="index">
                    {{item.data.substring(2).substring((index-1)*64,index*64)}}
                  </div>
<!--                  [_value] : 1141890000000000-->
                </div>
              </div>

            </div>
            </div>

<!--            Intrnal Txns-->
            <div v-show="showTab==2" class="detail-content">
                <InternalTxnsTable v-if="internalList" :data="internalList"/>
            </div>



          </div>
          <div v-else class="detail">
            <div class="detail-title">Transaction Details</div>
            <div class="detail-tab pt-3">
              <div @click="showTab=0" :class="showTab==0 ?'detail-tab-text-click':''" class="detail-tab-text">Overview</div>
              <div v-if="eventList && eventList.length > 0" @click="showTab=1" :class="showTab==1 ?'detail-tab-text-click':''" class="detail-tab-text">Logs ({{eventList.length}})</div>
              <div v-if="internalList && internalList.length > 0" @click="actionInternalTxns(showTab=2)" :class="showTab==2 ?'detail-tab-text-click':''" class="detail-tab-text">Internal Txns</div>
            </div>
            <div class="w-100 d-flex flex-column align-items-center mt-3">
              <img style="width: 20%" src="../../images/transtion/error.svg"/>
              <div class="pt-3 font-weight-light" style="font-size: 16px">Sorry, We are unable to locate this TxnHash</div>
            </div>
          </div>
      </div>
    </template>

    <script>
    import moment from "moment";
    import { updateAge, getSortAddress } from '@/util/index'
    import { Decimal } from 'decimal.js'
    import Copy from "@/views/_frame/copy";
    import InternalTxnsTable from "@/views/comp_table/internal_txns_table";

    export default {
    name: "detail",
      components: {InternalTxnsTable, Copy},
      data() {
        return{
          showDefaultView:0,//显示view input as
          showViewInput:false, //显示view input as
          showTanfers:false,//显示Token Transfer更多数据
          showTab:0,//切换栏
          showClick:false, //click,
          hash: '',
          transaction: '',
          inputDataArr:[],//inputdata
          blockHeight: 0,
          eventList: null,
          tokenTranList: null,//Token Transfer数据
          tokenTranTenList:null,//Token Transfer前十条数据
          tokenTranMoreList:null,//Token Transfer前十条后面的数据
          methodList: null,
          contract: null,
          internalList:null, //内部交易列表
          methodsDetail:null,//
        }
      },
      methods:{
        colseViewInputTab() {
          this.showViewInput=false
        },
        //地址转换
        getSortAddress(val) {
          return getSortAddress(val)
        },
        parseBalance(value) {
          if (value === '0x') {
            return 0
          } else {
            return Number(value) / 1e18
          }
        },
        getTransactionFee(val){
          if(!val){
            return 0
          }
          return this.parseValToMap(new Decimal(val.gasPrice).mul(new Decimal(val.gasUsed)))
        },
        parseValToMap(val){
          if(!val){
            return 0
          }
          return parseFloat(new Decimal(val).div(new Decimal(1000000000000000000)))
        },
        parseValToGWei(val){
          if(!val){
            return 0
          }
          return parseFloat(new Decimal(val).div(new Decimal(1000000000)))
        },
        updateTimestamp(val) {
          return updateAge(val)
        },
        blockDate (val) {
          if (this.error) {
            return ''
          }
          return moment(val).format('MMM Do YYYY, HH:mm:ss Z')
          // return (new Date(this.block.timestamp)).toGMTString()
        },
        actionSliceData(nums) {
          if (nums.length >= 64) {
            const c = nums.substring(0, 64)
            this.inputDataArr.push(c)
            this.actionSliceData(nums.substring(64))
          }
        },
        getDetail(){
          let v = this
          v.api('txsByHash', {
            txHash: v.hash
          }, {
            vue: v,
            key_data: 'data',
          }).then(function (res) {
            // console.log('getTransactionDetail',res)
            if (res.code==200) {

              v.transaction = res.data.transaction

              let inputData =  v.transaction.input.slice(10)

              v.actionSliceData(inputData)

              console.log(v.inputDataArr)

              if (res.data.methods) {
                v.methodsDetail = res.data.methods
              }else {
                v.methodsDetail = null
              }
              v.blockHeight = res.data.blockHeight
              // console.log('====',v.getTransactionFee(v.transaction))
            }
          })
        },
        getEvent(){
          let v = this
          v.api('transactionEventByHash', {
            txHash: v.hash
          }, {
            vue: v,
            key_data: 'data',
          }).then(function (res) {
            // console.log('transactionEventByHash',res)
            if (res.code==200) {
              v.eventList = res.data.logslist
              v.tokenTranList = res.data.tokenTranList
              // console.log('==========',  v.tokenTranList)
              v.tokenTranTenList=  v.tokenTranList.slice(0,10)
              v.tokenTranMoreList=  v.tokenTranList.slice(10)
              v.methodList = res.data.methodList
              v.contract = res.data.contract
            }
          })
        },
        //获取内部交易 Internal Tnxs
        async actionInternalTxns() {
          let v = this
          let result = await v.api('internalTnxsList', {
            txHash: v.hash
          },{
            vue: v,
            key_data: 'data',
          })
          this.internalList=result.data.list
          // console.log('internal Tnxs',result)
        }
      },
      mounted() {
        this.hash = this.$route.params.hash
        this.getDetail()
        this.getEvent();
        this.actionInternalTxns()
      }
    }
    </script>

    <style scoped lang="scss">

    .detail {

    }

    .detail-title {
      font-family: 'poppinSemiBold';
      font-weight: 600;
      font-size: 30px;
    }

    .detail-tab {
      font-weight: 600;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .detail-tab-text {
      font-family: 'poppinSemiBold';
      width: 126px;
      height: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 10px 10px 0 0 ;
    }

    .detail-tab-text-click {
      background: white;
      color:#3772ff;
    }

    .detail-content {
      padding: 48px 30px;
      width: 100%;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
      border-radius:0 0 10px 10px;
      background: white;
    }

    .detail-content-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 13px;
      span:nth-child(1) {
        font-weight: 600;
        width: 15%;
        font-family: 'poppinSemiBold';
      }
      span:nth-child(2) {}
    }

    .detail-status-success {
      button {
        width: 83px;
        height: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #78D286;
        border-radius: 8px;
        color: #FFFFFF;

      }
    }

    .detail-status-error {
      button {
        padding: 5px 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background:#3772ff;
        border-radius: 8px;
        color:  white;

      }
    }

    .detail-content-item-s {
      padding-top: 25px;
    }
    .detail-content-item-trans {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }
    .detail-content-item-topics {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }

    .detail-item-block {
      color:#3772ff;
      span {
        color: black;
        opacity: 0.4;
        padding-left: 10px;
      }
    }

    .detail-item-token-icon {
      width: 16px;
    }

    .detail-content-line {
      margin-top:  46px;
      width: 100%;
      height: 1px;
      background: #000000;
      opacity: 0.1;
      border-radius: 0.5px;
    }

    .detail-more {
      padding-top: 30px;
      button {
        width: 159px;
        height: 50px;
        background: rgba(55, 114, 255, 0.06);
        border-radius: 5px;
        color:#3772ff;
        font-weight: 600;
        font-size: 13px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-family: 'poppinSemiBold';
      }
      img {
        width: 9px;
        margin-left: 10px;
      }
    }

    .detail-item-input {
      //overflow-x: scroll;
      width: 80%;
      padding: 15px;
      background: #f3f7ff;
      border-radius: 5px;
      word-wrap: break-word;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      div {
        width: 100%;
      }
    }

    .detail-item-input-text {
      width: 100%;
      span {
        font-family: 'poppinsRegular' !important;
        width: 100% !important;
      }
    }

    .detail-item-view {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      button {
        outline-style: none;
        border: 0;
        width: 130px;
        height: 33px;
        border-radius: 5px;
        background-color: #3772ff;
        color: white;
        font-size: 12px;
        font-weight: 600;
        text-align: center;
        img {
          margin-left: 5px;
          width: 12px;
        }
      }
    }

    .detail-item-view-tab {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      top: 40px;
      width: 130px;
      height: 50px;
      background-color: #fff;
      background-clip: padding-box;
      border: 0 solid rgba(0,0,0,.15);
      border-radius: 0.35rem;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
      span {
        cursor: pointer;
        font-weight: 0 !important;
        font-family: 'poppinsRegular' !important;
        height: 25px !important;
        line-height: 25px ;
        width: 100% !important;
        text-align: left;
        padding-left: 15px;
      }
    }

   .detail-content-click {
      padding-bottom: 20px;
    }

   .detail-item-topics {
     margin-top: 10px;
     display: flex;
     flex-direction: row;
     align-items: center;
     span:nth-child(1) {
       width: 30px;
       height: 30px;
       display: flex;
       flex-direction: column;
       align-items: center;
       justify-content: center;
       background: #f3f7ff;
       border-radius: 5px;
       font-family: 'poppinSemiBold';
     }
     img {
       width: 12px;
       margin: 0 10px;
     }
   }

   .detail-item-topics:nth-child(1){
     margin-top: 0;
   }

   .detail-content-two {
     padding-bottom: 315px;
   }

   .log-content {
     margin-top: 20px;
     border: 1px solid#3772ff;
     border-radius: 10px;
     padding: 20px;
   }

   .trans-token {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: flex-start;
     flex-wrap: wrap;
     margin-top: 10px;
   }

   .trans-token:nth-child(1) {
     margin-top: 0;
   }

    .detail-content-item {

      .detail-item-input-num {
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          font-weight: 0;
          letter-spacing:1px;
          width: 50px;
          font-family: 'poppinsRegular' !important;
        }
      }
    }



    @media (max-width: 1200px) {
     .detail-content-item {
       span:nth-child(1) {
         width: 21%;
       }
     }
     .trans-token {
       display: flex;
       flex-direction: column;
       align-items: flex-start;

     }
   }


    </style>
